import { GlobeIcon, LogoutIcon } from "@heroicons/react/outline";
import React, { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { clearAuthCredentials } from "../../api/helpers/authHelpers";
import { useAuth } from "../../context/AuthContext";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import ChangeLangModal from "../language/ChangeLangModal";
import LogoutConfirmationModal from "../modal/LogoutConfirmationModal";
type SideFooterProps = {
  tutor?: {
    img?: string | null;
    name: string;
    usertype: string;
    actionName: string;
    action: any;
  } | null;
  langModal: boolean;
  setLangModal: Dispatch<SetStateAction<boolean>>;
};
function SideFooter({ tutor, setLangModal, langModal }: SideFooterProps) {
  const LocalBasePath = "sidenav";
  const Context = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);

  const logoutConfirmation = (logoutStatus: boolean) => {
    if (logoutStatus) Context?.logout();
    else setShowLogoutModal(false);
  };
  return (
    <div>
      <button
        onClick={() => setShowLogoutModal(true)}
        data-cy="signout"
        className={
          "w-full text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2  lg:px-4 py-2 text-sm font-medium rounded-md  mb-5"
        }
      >
        <LogoutIcon
          className={
            "text-gray-400 group-hover:text-gray-500 ltr:mr-3 rtl:ml-3 h-6 w-6"
          }
          aria-hidden="true"
        />
        {t(`${LocalBasePath}.signout`)}
      </button>
      {!!tutor && (
        <div className="flex mb-2 border-t border-gray-200 ltr:pl-2 rtl:pr-2">
          <button
            onClick={() => () => tutor.action()}
            className="flex-shrink-0 block pt-4 group"
          >
            <div className="flex items-center">
              <div>
                <UserProfilePictureAvatar
                  profilePictureUrl={tutor.img}
                  className="w-12 h-12 mx-auto"
                  alt="sand-user-img"
                />
              </div>
              <div className="ml-3">
                <h1 className="text-sm font-medium text-gray-500 group-hover:text-gray-700">
                  {" "}
                  {tutor.name}{" "}
                </h1>
                <div className="flex items-center justify-center ">
                  <p className="text-sm font-medium text-gray-500 group-hover:text-gray-700">
                    {" "}
                    {tutor.usertype} .{" "}
                  </p>
                  {!!tutor.actionName && (
                    <p className="text-sm text-brandblue-700">
                      {" "}
                      {tutor.actionName}{" "}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </button>
        </div>
      )}
      <ChangeLangModal open={langModal} setOpen={setLangModal} />
      <LogoutConfirmationModal
        isOpen={showLogoutModal}
        onClose={logoutConfirmation}
      />
    </div>
  );
}
export default SideFooter;
